<template>
  <jade-list-item
    :label="file.name"
    :variant="fileDetails.listItemVariant"
    :description="$t(fileDetails?.description, { limit })"
  >
    <template #leading>
      <jade-icon
        :use="fileDetails.iconUse"
        :color="fileDetails.iconVariant"
      />
    </template>
    <template #trailing>
      <jade-icon-button
        icon="trash"
        size="medium"
        :variant="fileDetails.buttonVariant"
        :disabled="fileIsLoading"
        @click="deleteFile"
      />
    </template>
  </jade-list-item>
</template>
<script>
import { JadeIcon, JadeListItem, JadeIconButton } from '@jade'

const FILE_ERRORS = {
  EXTENSION_FILE_ERROR: 'invalid.file',
  SIZE_FILE_ERROR: 'file.too-large',
  TRANSACTION_FILE_ERROR: 'transaction.file.error',
  DISPUTE_BLOCKED_ERROR: 'dispute.blocked'
}

export default {
  name: 'FileListItem',
  components: {
    JadeIcon,
    JadeIconButton,
    JadeListItem
  },
  props: {
    file: Object,
    fileIsLoading: Boolean,
    limit: {
      type: Number,
      default: 15
    }
  },
  computed: {
    fileIsInvalid () {
      return !!this.file?.error
    },
    fileDetails () {
      if (!this.fileIsLoading) {
        if (this.fileIsInvalid) {
          return this.structureError()
        }

        return this.structureActive()
      }

      return this.structureDefault()
    }
  },
  methods: {
    deleteFile () {
      this.$emit('deleteFile', this.file)
    },
    structureDefault () {
      return {
        listItemVariant: 'neutral',
        iconUse: 'file-folded',
        iconVariant: 'low',
        buttonVariant: 'neutral-subtle',
        description: this.$t('loading')
      }
    },
    structureActive () {
      return {
        ...this.structureDefault(),
        listItemVariant: 'active',
        iconVariant: 'brand',
        description: null
      }
    },
    structureError () {
      return {
        listItemVariant: 'danger',
        iconUse: 'circle-error',
        iconVariant: 'negative',
        buttonVariant: 'danger-subtle',
        description: FILE_ERRORS[this.file.error] || this.file.error
      }
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "invalid.file": "Formato inválido, o anexo deve ser do tipo JPEG ou PDF",
      "file.too-large": "O documento anexado excede o limite de tamanho de {limit}MB",
      "transaction.file.error": "Não foi possível identificar a contestação. Verifique o nome do arquivo",
      "dispute.blocked": "A contestação identificada já possui uma disputa em andamento",
      "loading": "Validando arquivo..."
    },
    "en-US": {
      "invalid.file": "Invalid format, the attachment must be in jpeg or pdf format",
      "file.too-large": "The attached document exceeds the {limit}MB size limit",
      "transaction.file.error": "Unable to identify the transaction",
      "dispute.blocked": "The identified dispute already has a dispute in progress",
      "loading": "Loading..."
    }
  }
</i18n>
